export const ADD_USER_TABS = 'ADD_USER_TABS'
export const REMOVE_USER_TABS = 'REMOVE_USER_TABS'
export const CLOSE_ALL_TABS = 'CLOSE_ALL_TABS'
export const SET_ACTIVE_USER = 'SET_ACTIVE_USER'
export const SET_ACTIVE_CHANNEL = 'SET_ACTIVE_CHANNEL'
export const SET_EXPANDED_USER_TAB = 'SET_EXPANDED_USER_TAB'
export const CLEAN_EXPANDED_USER_TAB = 'CLEAN_EXPANDED_USER_TAB'
export const UPDATE_USER_TABS = 'UPDATE_USER_TABS'
